import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe5da25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-edit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "app-component-header__title" }, "Edit Group", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "edit" }
const _hoisted_7 = { class: "edit-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-title" }, "Group Name", -1))
const _hoisted_9 = { class: "edit-info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-title" }, "Group Info", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_group_image = _resolveComponent("add-group-image")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_header, { class: "header" }, {
      "top-middle": _withCtx(() => [
        _hoisted_2
      ]),
      "top-right": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          class: "back-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateGroupData && _ctx.updateGroupData(...args)))
        }, " Done ")
      ]),
      "top-left": _withCtx(() => [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"])),
          class: "back-link"
        }, _hoisted_5)
      ]),
      bottom: _withCtx(() => [
        _createVNode(_component_add_group_image, {
          isEditing: "",
          "group-cover": _ctx.groupCover,
          onUpdateCoverPhoto: _ctx.handleUpdateCoverPhoto
        }, null, 8, ["group-cover", "onUpdateCoverPhoto"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_input, {
          modelValue: _ctx.formData.groupName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.groupName) = $event)),
          placeholder: "Seattle team"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_el_input, {
          modelValue: _ctx.formData.groupInfo,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.groupInfo) = $event)),
          placeholder: "This group includes everyone who works at the Seattle Location"
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}